import Product from "./product";
import Coupon from "./coupon";

export default class Cart {
  readonly canCheckout: boolean;
  readonly cartSessionId: string;
  readonly currency: string;
  readonly globalMessage: string;
  readonly hasQuantityChange: boolean;
  readonly hasSoldoutItems: boolean;
  readonly items: Product[];
  readonly totalItems: number;
  readonly totalUniqueItems: number;
  readonly totalItemsBuyPrice: number;
  readonly totalItemsBuyPriceString: string;
  readonly totalItemsDisplayPrice: number;
  readonly totalItemsDisplayPriceString: string;
  readonly totalItemsDiscountValue: number;
  readonly totalItemsDiscountValueString: string;
  readonly totalItemsDiscountPercentage: number;
  readonly payOfferItems: string[];
  readonly coupons: Coupon[];

  constructor(data: { [x: string]: any }) {
    this.canCheckout = data.can_do_checkout;
    this.cartSessionId = data.cart_session_id;
    this.currency = data.currency;
    this.globalMessage = data.global_message;
    this.hasQuantityChange = data.has_quantity_change;
    this.hasSoldoutItems = data.has_soldout_items;
    this.items = data.items.map((item: any) => new Product(item));
    this.totalItems = data.total_items_count;
    this.totalUniqueItems = data.total_unique_items;
    this.totalItemsBuyPrice = data.total_items_buy_price;
    this.totalItemsBuyPriceString = data.total_items_buy_price_string;
    this.totalItemsDisplayPrice = data.total_items_display_price;
    this.totalItemsDisplayPriceString = data.total_items_display_price_string;
    this.totalItemsDiscountValue = data.total_items_discount_value;
    this.totalItemsDiscountValueString = data.total_items_discount_value_string;
    this.totalItemsDiscountPercentage = data.total_items_discount_percentage;
    this.payOfferItems = data.pay_offer_items || [];
    this.coupons = data.coupons?.all_offers?.map((coupon: any) => new Coupon(coupon)) || [];
  }
}
